import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3748b5f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs_18 fw_700" }, "Summary", -1))
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Bag type"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Weight")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between title"
}
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "ps-4"
}
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between title" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center mt-5"
}
const _hoisted_11 = {
  key: 0,
  class: "fs_14 me-3"
}
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_material_composition_summary = _resolveComponent("material-composition-summary")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.bagData.bagType), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(_ctx.bagComposition.totalWeight, 2)) + "gr", 1)
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bagComposition.percentageCompositionValues, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name
          }, [
            (item.parentName == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, _toDisplayString(item.name), 1),
                  (!_ctx.isReadOnly && _ctx.bagComposition.percentageCompositionValues.some(x => x.parentName == item.name))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-secondary btn-sm",
                        onClick: ($event: any) => (_ctx.openMacroModal(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Fill all sub-elements",
                          text: "Fill all sub-elements"
                        })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_material_composition_summary, {
                    row: item,
                    isReadOnly: _ctx.isReadOnly,
                    onEdit: ($event: any) => (_ctx.openMaterialsModal(item, false))
                  }, null, 8, ["row", "isReadOnly", "onEdit"])
                ]))
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_localized_text, {
            type: "h4",
            localizedKey: "Sangle",
            text: "Sangle"
          }),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCompositionToSangle()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "+ Add another sangle composition",
                  text: "+ Add another sangle composition"
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bagComposition.sangleValues, (sangle) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ps-4",
            key: sangle.name
          }, [
            _createVNode(_component_material_composition_summary, {
              row: sangle,
              isReadOnly: _ctx.isReadOnly,
              actionDisabled: sangle.weight <= 0,
              onEdit: ($event: any) => (_ctx.openMaterialsModal(sangle, true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_form_field, {
                  type: "number",
                  labelKey: "Grams",
                  labelValue: "Grams",
                  placeholderKey: "Grams",
                  placeholderValue: "Grams",
                  modelValue: sangle.weight,
                  "onUpdate:modelValue": ($event: any) => ((sangle.weight) = $event),
                  readonly: _ctx.isReadOnly,
                  class: "mb-3 w-100"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
              ]),
              _: 2
            }, 1032, ["row", "isReadOnly", "actionDisabled", "onEdit"])
          ]))
        }), 128)),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-secondary me-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Previous",
                  text: "Previous"
                })
              ]),
              (_ctx.pendingCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Still to fill:",
                      text: "Still to fill:",
                      class: "me-1"
                    }),
                    _createTextVNode(_toDisplayString(_ctx.pendingCount), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-tertiary",
                disabled: _ctx.isDisabled,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/bag-calculator/chemicals/' + _ctx.estimationIdentifier)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Continue",
                  text: "Continue"
                })
              ], 8, _hoisted_12)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}